const InstitutionsAdmins = () => import("./views/InstitutionsAdmins.vue");
const InstitutionsAdminEdit = () => import("./views/InstitutionsAdminEdit.vue");
const InstitutionsAdmin = () => import("./views/InstitutionsAdmin.vue");

const route = "/institutionsAdmins";

export default [
  {
    path: route,
    name: "institutionsAdmins.list",
    component: InstitutionsAdmins,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "institutionsAdmins.create",
    component: InstitutionsAdminEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:institutionsAdminId`,
    name: "institutionsAdmins.details",
    component: InstitutionsAdmin,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:institutionsAdminId/edit`,
    name: "institutionsAdmins.edit",
    component: InstitutionsAdminEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
